import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import { getApiClient } from "../api-client";

export interface OrganizerClub {
  id: string;
  name: string;
  image: string | null;
}

interface OrganizerClubsResponse {
  clubs: OrganizerClub[];
}

/**
 * Lists clubs the signed-in user organizes (OWNER/ADMIN of a non-Plotlounge club).
 * Powers the cockpit sidebar and ClubGuard.
 */
export function useOrganizerClubs() {
  const { isLoaded, isSignedIn } = useAuth();

  return useQuery<OrganizerClub[]>({
    queryKey: ["me", "organizer-clubs"],
    enabled: isLoaded && isSignedIn,
    queryFn: async () => {
      const res = await getApiClient().get<OrganizerClubsResponse>(
        "/users/me/organizer-clubs",
      );
      return res.clubs;
    },
    staleTime: 30 * 1000,
  });
}
